export class ThemeConfig {
  static layout = 'vertical'; // vertical, Horizontal
  static pre_layout: string = null; // null, layout-2, layout-2-2, layout-3, layout-4, layout-4-2, layout-6, layout-8
  static isCollapseMenu = false; // true, false
  static layout_type = 'menu-dark'; // menu-dark, menu-light, dark,
  static isNavIconColor = false; // true, false
  static headerBackColor = 'header-default'; // header-default, header-blue, header-red, header-purple, header-lightblue, header-dark
  static navBackColor = 'navbar-default'; // navbar-default, navbar-blue, navbar-red, navbar-purple, navbar-lightblue, navbar-dark
  static navBrandColor = 'brand-default'; // brand-default, brand-blue, brand-red, brand-purple, brand-lightblue, brand-dark
  static navBackImage = false; // false, navbar-image-1, navbar-image-2, navbar-image-3, navbar-image-4, navbar-image-5
  static isRtlLayout = false; // false, true
  static isNavFixedLayout = true; // false, true
  static isHeaderFixedLayout = false; // false, true
  static isBoxLayout = false; // false, true
  static navDropdownIcon = 'style1'; // style1, style2, style3
  static navListIcon = 'style1'; // style1, style2, style3, style4, style5, style6
  static navActiveListColor = 'active-default'; // active-default, active-blue, active-red, active-purple, active-lightblue, active-dark
  static navListTitleColor = 'title-default'; // title-default, title-blue, title-red, title-purple, title-lightblue, title-dark
  static isNavListTitleHide = false; // false, true
  static layout_6_Background = '#23b7e5'; // used only for pre-layout = layout-6
}
